import { useEffect } from 'react'
import { reconnect } from '@wagmi/core'
import { config } from '../config/wagmi'

const useEagerConnect = () => {
  useEffect(() => {
    const connectorId = window.localStorage.getItem("connectorId")
    if (connectorId) {
      reconnect(config)
    }
  }, [])
}

export default useEagerConnect
